import { createContext, type ReactNode } from 'react';
import { FeatureFlagsProvider } from './FeatureFlagsContext';

type ContextProps = {
  /**
   * returns true if impersonatorEmail, impersonatorUserToken exists and isPostingPathAdmin is true
   */
  isImpersonator: boolean;
  /**
   * returns true if mobileDetect.mobile() is true, regardless of screenwidth
   */
  isMobileDevice: boolean;
  /**
   * returns true if user is an admin
   */
  isPostingPathAdmin: boolean;
};

/**
 * AppContext stores app specific data, not specific to the inbox page.
 */
export const AppContext = createContext<ContextProps>({} as ContextProps);

interface AppContextProviderProps {
  children: ReactNode;
  value: ContextProps;
}

export const AppContextProvider = ({ children, value }: AppContextProviderProps) => {
  return (
    <FeatureFlagsProvider>
      <AppContext.Provider value={value}>{children}</AppContext.Provider>
    </FeatureFlagsProvider>
  );
};
